// extracted by mini-css-extract-plugin
module.exports = {"header":"AnalyticsEventsHeader_header__3dupc","tabs":"AnalyticsEventsHeader_tabs__2jpnR","tableHead":"AnalyticsEventsHeader_tableHead__APd-0"};